import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { controlSize } from "../../../design-system/tokens/controlSizes";
import { duration, easing } from "../../../design-system/tokens/transitions";

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${controlSize.pill.md};
  height: ${controlSize.pill.md};
  padding: 0;
  border: none;
  border-radius: ${borderRadius.lg};
  background: transparent;
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  transition: background-color ${duration.fast} ${easing.smooth}, color ${duration.fast} ${easing.smooth};

  &:hover {
    background: ${rawColors.structural[100]};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.stroke[200]};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
